import { AnalyticsEvent } from "./AnalyticsEvent.js";
import type {
    AnalyticsEventType } from "./AnalyticsEventType.js";
import {
    ANALYTICS_GAME_PREFIX,
} from "./AnalyticsEventType.js";
import { GameMode } from "../game/GameMode.js";
import type { Ruleset } from "../game/Ruleset.js";
import type { BotType } from "../game/BotType.js";


function generateEventAction(
    type: AnalyticsEventType,
    mode: GameMode | null,
    difficulty: BotType | undefined,
): string {
    const modeName = (mode ? mode.getName() : "unknown");
    let difficultySuffix = "";
    if (mode === GameMode.COMPUTER) {
        difficultySuffix = (difficulty ? `_${difficulty.getName()}` : "_unknown");
    }
    return `${type.getEventCategory()}_${modeName}${difficultySuffix}`;
}


function generateEventName(
    type: AnalyticsEventType,
    ruleset: Ruleset | null,
): string {
    const typeName = (ruleset ? ruleset.getName() : "custom");
    return `${type.getEventCategory()}_${typeName}`;
}


export class GameAnalyticsEvent extends AnalyticsEvent {
    constructor(
        type: AnalyticsEventType,
        mode: GameMode | null,
        ruleset: Ruleset | null,
        difficulty: BotType | undefined,
    ) {
        super(
            type,
            generateEventAction(type, mode, difficulty),
            generateEventName(type, ruleset),
        );
        if (type.getPrefix() !== ANALYTICS_GAME_PREFIX)
            throw new Error(type.getEventCategory() + " is not a game event");
    }
}
